import { RecentlyViewed } from '@theme/recently-viewed-products';
import { buildSectionSelector, morphSection, sectionRenderer } from '@theme/section-renderer';

/**
 * @param {ParentNode} container
 */
function executeScripts(container) {
  container.querySelectorAll('script').forEach((script) => {
    const newScript = document.createElement('script');

    for (const attribute of script.attributes) {
      newScript.setAttribute(attribute.name, attribute.value);
    }

    newScript.textContent = script.textContent;
    script.replaceWith(newScript);
  });
}

class EvryRecentlyViewedSlider extends HTMLElement {
  /** @type {boolean} */
  #initialized = false;

  connectedCallback() {
    if (this.#initialized) return;
    this.#initialized = true;
    this.#load();
  }

  async #load() {
    const sectionId = this.dataset.sectionId;
    const currentProductId = this.dataset.currentProductId;
    const minProducts = Number.parseInt(this.dataset.minProducts || '5', 10);
    const searchUrl = this.dataset.searchUrl;
    const sectionElement = this.closest('.shopify-section');

    if (!sectionId || !searchUrl) {
      sectionElement?.remove();
      return;
    }

    if (currentProductId) {
      RecentlyViewed.addProduct(currentProductId);
    }

    const viewedProducts = RecentlyViewed.getProducts();

    if (viewedProducts.length < minProducts) {
      sectionElement?.remove();
      return;
    }

    const productIds = viewedProducts.filter((id) => id !== currentProductId);

    if (productIds.length === 0) {
      sectionElement?.remove();
      return;
    }

    const url = new URL(searchUrl, location.origin);
    url.searchParams.set('q', productIds.map((id) => `id:${id}`).join(' OR '));
    url.searchParams.set('resources[type]', 'product');

    try {
      const html = await sectionRenderer.getSectionHTML(sectionId, false, url);
      const parsed = new DOMParser().parseFromString(html, 'text/html');

      if (!parsed.querySelector('.now-trending-slider--recently-viewed')) {
        sectionElement?.remove();
        return;
      }

      await morphSection(sectionId, html);

      const morphedSection = document.getElementById(buildSectionSelector(sectionId));

      if (morphedSection) {
        executeScripts(morphedSection);
        document.dispatchEvent(
          new CustomEvent('shopify:section:load', {
            detail: { sectionId },
          })
        );
      }
    } catch (error) {
      console.error('Recently viewed slider failed to load', error);
      sectionElement?.remove();
    }
  }
}

if (!customElements.get('evry-recently-viewed-slider')) {
  customElements.define('evry-recently-viewed-slider', EvryRecentlyViewedSlider);
}
